const Fr = {
  "dashboard_contact-inappr-equip":
    "Contact avec la COVID-19 avec un équipement inapproprié",
  "dashboard_multi-symptoms": "Symptômes multiples de COVID-19",
  "dashboard_symptom-employee-health":
    "Symptômes depuis un contact avec Santé et Sécurité employés",
  "dashboard_travel-outside": "Voyage à l'extérieur du Nouveau-Brunswick",
  account_emailAddress: "Adresse courriel",
  account_english: "English",
  account_firstName: "Prénom",
  account_french: "Français",
  newpass: "Tapez un nouveau mot de passe",
  confpass: "Retapez le nouveau mot de passe",
  req_date: "Date Demandée",
  account_interfaceLanguage: "Langue d'interface",
  card_Num: "Numéro de carte d’accès",
  email_formatInvalid: "Format invalide",
  min_six_char: "Au moins 6 caractères",
  signUpMsg: "S'INSCRIRE",
  preferredLang: "Langue de préférence",
  min_one_digit: "Au moins 1 chiffre",
  min_one_special_char: "Au moins 1 caractère spécial",
  min_one_upper: "Au moins 1 lettre majuscule",
  min_one_lower: "Au moins 1 lettre minuscule",
  pass_dont_match: "Les mots de passe ne correspondent pas.",
  completedSignUp:
    "Un lien d’activation a été envoyé à votre courriel. Veuillez cliquer sur ce lien pour activer votre compte.",
  submitError1:
    "Un compte existe déjà pour ce courriel et/ou ce numéro de carte d’accès.",
  submitError2:
    "Veuillez communiquer avec votre administrateur ou essayer de vous connecter.",
  card_exists: "Le numéro de carte existe déjà",
  email_exists: "Cette adresse email existe déja.",
  import_date: "Date d'importation",
  business_type: "Type d'entreprise",
  keywords: "Mots clés",
  importer: "Importateur",
  refine: "Affiner",
  preview: "Aperçu",
  idp: "IDP",
  checkbox: "[ - ]",
  file_name: "Nom du fichier",
  file_date: "Date (UTC)",
  is_processed: "Processeurs",
  linked_to: "Liens",
  card_associated: "Cette carte est associée à un autre email",
  account_lastName: "Nom",
  account_minLength: "6 caractères minimum",
  account_oneDigit: "Au moins 1 chiffre",
  account_oneLowercaseLetter: "Au moins 1 minuscule",
  account_oneSpecialChar: "Au moins un caractère spécial",
  account_oneUppercaseLetter: "Au moins 1 majuscule",
  account_personalInfo: "Infos personnelles",
  account_settings: "Paramètres",
  account_update: "Mettre à jour",
  account_updateFail: "Mauvais mot de passe.",
  account_updateSuccessful: "Mise à jour réussie",
  required_field: "Champ obligatoire",
  existing_carrier: "Transporteur existant",
  apply_changes: "Appliquer les modifications à :",
  this_occurrence_only: "Cette occurrence seulement",
  future_occurrences: "Cette occurrence et les suivantes",
  arcturus_cloud: "Arcturus Cloud",
  arcturus_status: "Arcturus Cloud Service Status",
  auth_backToSignIn: "Retour à la connexion",
  auth_change: "Changement",
  auth_emailAddress: "Nom d’utilisateur/Adresse courriel",
  auth_iHaveAVerificationCode: "J'ai un code de vérification.",
  auth_incorrectEmailAddress: "Adresse courriel incorrecte.",
  auth_invalidVerificationCode: "Code de vérification invalide.",
  auth_keepMeLoggedIn: "Rester connecté",
  auth_login: "Se connecter",
  auth_sendCode: "Envoyer le code",
  auth_emailOtpSignInHelp: "Nous vous enverrons un code à usage unique par courriel pour vous connecter.",
  auth_otpTitle: "Connexion",
  auth_otpDesc: "Entrez le code à usage unique envoyé à votre courriel.",
  auth_mfaTitle: "Authentification multifacteur",
  auth_mfaDesc: "Entrez le code de vérification envoyé à votre courriel.",
  auth_codeResent: "Code renvoyé avec succès",
  auth_resendCode: "Renvoyer le code",
  createquestion: "CRÉER QUESTIONNAIRE",
  auth_logout: "Se déconnecter",
  auth_minLength: "6 caractères minimum",
  auth_oneDigit: "Au moins 1 chiffre",
  auth_oneLowercaseLetter: "Au moins 1 minuscule",
  auth_oneSpecialChar: "Au moins 1 caractère spécial",
  auth_oneUppercaseLetter: "Au moins 1 majuscule",
  auth_pleaseEnterAnEmailAddress: "Veuillez entrer votre courriel.",
  auth_pleaseEnterAPassword:
    "Veuillez entrer un mot de passe / code de vérification",
  auth_returnToLogin: "Retour à la connexion",
  auth_submit: "Soumettre",
  auth_verificationCode: "Code de vérification",
  common_add: "Ajouter",
  one: "Un",
  multiple: "Multiple",
  colon: " :",
  common_addAndReplace: "Ajouter et remplacer",
  common_all: "Tout",
  common_color: "Couleur",
  common_companiesSitesZones: "Compagnies/Sites/Zones",
  common_day: "Jour",
  common_deactivate: "Désactiver",
  common_device: "Périphérique",
  common_device_add: "Ajouter Périphérique",
  common_exporting: "Exportation en cours",
  common_fri: "Ven",
  common_friday: "Vendredi",
  common_from: "De",
  common_loading: "Chargement",
  common_luke: "Stockify",
  common_lukeAbout1:
    "La plateforme StockifyMD utilise l'intelligence artificielle (IA) et des règles d’affaires permettant la prise de décisions en temps réel.",
  common_lukeAbout2:
    "Notre plateforme StockifyMD aime apprendre. Elle utilise des interactions pour comprendre ce qui se passe, savoir quoi faire en utilisant des décisions factuelles. StockifyMD exécute ensuite des actions pour surmonter les défis de l'entreprise, fournissant une valeur mesurable en continu.",
  common_lukeAbout3: "StockifyMD apprend toujours, s'améliore toujours.",
  common_mon: "Lun",
  common_monday: "Lundi",
  common_new: "Nouveau",
  common_noOptions: "Pas d'option",
  common_noZoneInSite: "Aucune zone trouvée sur ce site",
  common_of: "sur",
  common_print: "Imprimer",
  common_send_email: "Envoyer un courriel",
  common_sat: "Sam",
  common_saturday: "Samedi",
  common_selected: "sélectionnés",
  common_selectSite: "Sélectionnez le site",
  common_selectSiteFirst: "Sélectionnez le site en premier",
  common_selectZone: "Sélectionnez la zone",
  common_site: "Site",
  common_site2: "Emplacement",
  common_sun: "Dim",
  common_sunday: "Dimanche",
  common_textCopiedToClipboard: "Texte copié dans le presse-papier.",
  common_thu: "Jeu",
  common_thursday: "Jeudi",
  common_to: "à",
  common_tue: "Mar",
  common_tuesday: "Mardi",
  common_upload: "Téléverser",
  common_wed: "Mer",
  common_wednesday: "Mercredi",
  common_week: "Semaine",
  common_zone: "Zone",
  companies_address: "Adresse",
  companies_assignedProfiles: "Profils assignés",
  companies_company: "Compagnie",
  sector: "Secteur",
  sidebar_supplychain: "WMS (Système de gestion d'entrepôt)",
  companies_companyNew: "Nouvelle compagnie",
  companies_companyType: "Type de compagnie",
  companies_createdSuccessfully: "Créé avec succès",
  companies_creationFailed: "la création a échoué",
  companies_device: "Périphérique",
  companies_deviceNew: "Nouveau périphérique",
  companies_devices: "Périphériques",
  companies_deviceType: "Type de périphérique",
  companies_externalDevices: "Périphériques externes",
  companies_lieaDevices: "Périphérique LIEA",
  companies_newCompany: "Nouvelle compagnie",
  companies_newDevice: "Nouveau périphérique",
  companies_newSite: "Nouveau site",
  companies_newZone: "Nouvelle Zone",
  companies_parentEdgeDevice: "Périphérique edge parent",
  companies_site: "Site",
  companies_siteNew: "Nouveau site",
  companies_siteType: "Type de site",
  companies_zone: "Zone",
  companies_zoneNew: "Nouvelle zone",
  companies_zones: "Zones",
  companies_zoneType: "Type de zone",
  delete: "Supprimer",
  unselect_commands: "Désélectionner les produits avec 'Commande en cours'",
  order_jrv: "COMMANDER",
  order_noun_jrv: "Commande",
  vmi_list: "Liste VMI",
  qty_abv: "Qté",
  order_request_warning:
    "Seuls les produits sélectionnés seront passés en commande.",
  edit: "Éditer",
  custom: "per.",
  custom_css: "120",
  dashboard_activeAverage: "Moyenne de la période active",
  dashboard_activeCases: "Cas actifs",
  dashboard_additionalMetrics: "Mesures additionnelles",
  dashboard_aggregateFunction: "Fonction d'agrégation",
  dashboard_all: "Tout",
  dashboard_allOk: "Tout OK",
  dashboard_allowed: "Accès autorisé",
  dashboard_allProfiles: "tous les profils",
  dashboard_allSites: "Tous les sites",
  dashboard_allSymptoms: "Tous les symptômes",
  dashboard_allTime: "Tous",
  dashboard_assets: "Biens",
  dashboard_assistance: "Assistance et refus",
  dashboard_assistanceRequired: "Aide requise",
  dashboard_assistanceTopReasons: "Raisons principales pour aide",
  dashboard_atLeast1Screening: "Au moins un triage",
  dashboard_automationEfficiency: "Efficacité de l'automatisation",
  dashboard_averageTime: "Temps moyen",
  dashboard_averageTimeAtGate: "Temps moyen à la barrière",
  dashboard_averageTimeAtKiosk: "Temps moyen au kiosque",
  dashboard_averageTimeInYard: "Temps moyen dans la cour",
  dashboard_averageTimeTrailerYard: "Temps moyen des remorques dans la cour",
  dashboard_averageTimeTruckSite: "Temps moyen des camions sur le site",
  dashboard_barcode: "Code-barres :",
  dashboard_bodytemp: "Température du corps",
  dashboard_by_carriers: "Vue par transporteur",
  dashboard_by_sites: "Vue par site",
  dashboard_byCarrier: "Vue par transporteur",
  dashboard_bySite: "Vue par site",
  dashboard_carrier: "Transporteur",
  dashboard_cars: "Voitures",
  dashboard_chooseMetrics: "Sélectionner les paramètres",
  dashboard_clear: "Effacer",
  dashboard_comments: "Commentaires",
  dashboard_company: "Compagnie",
  dashboard_confirmedlaboratory: "Test de laboratoire confirmé",
  dashboard_contact: "Contact COVID-19",
  dashboard_containers: "Conteneurs",
  dashboard_cough: "Toux",
  dashboard_custom: "Personnalisées",
  dashboard_custom2: "Personnalisées",
  dashboard_date: "Date",
  dashboard_day: "jour",
  dashboard_days: "jours",
  dashboard_deltacars: "Voiture Delta",
  dashboard_deltatrailers: "Remorque Delta",
  dashboard_deltatrucks: "Camion Delta",
  dashboard_denied: "Accès refusé",
  dashboard_devices: "Périphériques(s)",
  dashboard_diarrhea: "Diarrhée",
  dashboard_display: "Afficher",
  dashboard_distinctLicensePlates: "Plaques d'immatriculations différentes",
  dashboard_driveIn: "Entrée camion",
  dashboard_driveInOutCounts: "Nombre d'entrées et de sorties de camion",
  dashboard_driveInPreAuth: "Préautorisation entrée camion",
  dashboard_driveInResult: "Résultat entrée camion",
  dashboard_driveOut: "Sortie camion",
  dashboard_driveOutPreAuth: "Préautorisation sortie camion",
  dashboard_driveOutResult: "Résultat sortie camion",
  dashboard_driverFirstname: "Prénom du conducteur",
  dashboard_driverFrAttempt:
    "tentative de reconnaissance faciale du conducteur",
  dashboard_driverLastname: "Nom du conducteur",
  dashboard_endDate: "Date de fin",
  dashboard_entrance: "Entrée",
  dashboard_entranceExit: "Entrée/Sortie",
  dashboard_entrances: "Entrées",
  dashboard_entrancesExits: "Entrées/Sorties",
  dashboard_entryExitAi: "Entrée/Sortie IA",
  dashboard_entryExitIA: "Entrée/Sortie IA",
  dashboard_entryStatus: "État d'entrée",
  dashboard_exit: "Sortie",
  dashboard_exits: "Sorties",
  dashboard_exportCSV: "Export CSV",
  dashboard_faceRecognized: "Correspondance visage",
  dashboard_failed_to_detect: "Échec détection",
  dashboard_failedSurveys: "Questionnaire avec symptômes",
  dashboard_fatigue: "Fatigue",
  dashboard_fever: "Fièvre détectée",
  dashboard_feverdetected: "Fièvre détectée",
  dashboard_fr: "FR:",
  dashboard_globalAverage: "Moyenne globale (avec 0)",
  dashboard_graph: "Graphique",
  dashboard_headache: "Mal de tête",
  dashboard_hours: "heure(s)",
  dashboard_hspSitesRiskChart: "HSP - Taux de risque sur le(s) site(s)",
  dashboard_humanCount: "Nombre de personnes",
  dashboard_humanIdentification: "Identification personne",
  dashboard_humans: "Personnes",
  dashboard_kioskAverageSurveyTime:
    "Temps moyen de réponse au questionnaire sur le kiosque :",
  dashboard_kioskMetrics: "Mesures associées au kiosque",
  dashboard_kioskOnSiteResults: "Résultats Kiosque/sur place",
  dashboard_kioskProfileIdentification: "Identification du profil au kiosque",
  dashboard_kioskQuestionnaireAverageWaitTime:
    "Durée moyenne du questionnaire au kiosque",
  dashboard_kioskThermalMeasurements: "Mesures de température au kiosque:",
  dashboard_kioskVisits: "Visites au kiosque",
  dashboard_last2days: "2 derniers jours",
  dashboard_last7days: "7 derniers jours",
  dashboard_lastDetectionOfProfiles:
    "Dernière détection des profils dans les sites et zones.",
  dashboard_lastWeek: "Dernière semaine",
  dashboard_leastPerformingZones: "Zones les moins performantes",
  dashboard_loadingData: "Chargement des données",
  dashboard_logType: "Type de journal",
  dashboard_lostOfSmell: "Perte d'odorat",
  dashboard_lostsmell: "Perte d'odorat",
  dashboard_lprMatch: "LPR reconnu",
  dashboard_max: "Max",
  dashboard_min: "Min",
  dashboard_misc: "Divers",
  dashboard_modifiedOn: "Modifié le",
  dashboard_nb_visits: "Nombre de visites",
  dashboard_nbDormantTrailers: "Nombre de remorques dormantes",
  dashboard_nbSelectedProfiles: "Nombre de profils sélectionnés :",
  dashboard_nbSelectedSites: "Nombre de sites sélectionnés :",
  dashboard_nbTrailerYard: "Nb de remorques dans la cour",
  dashboard_nbVisitTotal: "Nb total de visite",
  dashboard_no_visual_reference: "Aucune référence visuelle",
  dashboard_noDataFound: "Aucune donnée trouvée avec les paramètres fournis.",
  dashboard_noScreening: "Aucun triage",
  dashboard_nose: "Nez qui coule",
  dashboard_numberOfVehicles: "Nombre de véhicules",
  dashboard_numberOfVisits: "Nombre de visites",
  dashboard_ocrLprReadings: "Lectures OCR/LPR",
  dashboard_ocrMatch: "OCR reconnu",
  dashboard_onsite: "Sur place",
  dashboard_onsiteDecision: "Décisions sur le site",
  dashboard_onSites: "Sur le site",
  dashboard_others: "Autres",
  dashboard_peopleCount: "Nombre de personne",
  dashboard_period: "Période",
  dashboard_physicalcontact: "Contact physique",
  dashboard_privateVehicles: "Véhicules privés",
  dashboard_profilesSelected: "Profils sélectionnés",
  dashboard_protection: "Protection (résultats du sondage)",
  dashboard_questionnaireCount: "Compte questionnaires",
  dashboard_questionnaireResults: "Résultats sur le site et en ligne",
  dashboard_remote: "à distance",
  dashboard_requireAssistance: "Aide requise",
  dashboard_resetFilters: "Réinitialiser les filtres",
  dashboard_respiratory: "Problèmes respiratoires",
  dashboard_respiratoryproblems: "Problèmes respiratoires",
  dashboard_riskCategories: "Catégories de risque",
  category: "Catégorie",
  manu_name: "Manufacturier",
  manu_code: "Code manufacturier",
  dashboard_riskTooltip:
    'Ceci représente la somme des décisions "Aide requise" et "Accès refusé".',
  dashboard_sampleRate: "Taux d'échantillonnage",
  dashboard_screeningCoverage: "Couverture du triage",
  dashboard_search: "Rechercher",
  dashboard_securityGuard: "Agent de sécurité",
  dashboard_settings: "Paramètres",
  dashboard_shortnessbreath: "Souffle court",
  dashboard_showing: "Profils affichés",
  dashboard_site: "Site",
  dashboard_site2: "Site :",
  dashboard_smell: "Perte d'odorat ou goût",
  dashboard_soreness: "Douleurs musculaires",
  dashboard_startDate: "Date de début",
  dashboard_switchToDateRange: "Passer à une plage de dates",
  dashboard_switchToPeriod: "Passer à une période",
  dashboard_tailgate: "Talonnage",
  dashboard_tailgates: "Tailgates",
  dashboard_temp: "Température corporelle",
  dashboard_throat: "Mal de gorge",
  dashboard_time: "Heure",
  dashboard_today: "Aujourd'hui",
  dashboard_topReasons: "Principales raisons (aide requise)",
  dashboard_topSymptoms: "Principaux symptômes sur le site",
  dashboard_topVisitDuration: "Durée des visites les plus longues",
  dashboard_total: "Total",
  dashboard_totalEntrances: "Entrées totales",
  dashboard_totalExits: "Sorties totales",
  dashboard_totalNbOfProfiles: "Nombre total de profils",
  dashboard_totalOnsiteCounts: "Compte total sur site(s)",
  dashboard_totalOffsiteCounts: "Compte total hors site(s)",
  dashboard_Offsite: "Hors site(s)",
  dashboard_totalScreeningCounts: "Nombre total de triages",
  dashboard_totalVehicles: "Véhicules total",
  dashboard_totalVisits: "Visites totales :",
  dashboard_trailerDormantYard: "Remorque dormant dans la cour",
  dashboard_trailers: "Remorques",
  dashboard_trailersContainers: "Remorques/Conteneurs",
  dashboard_travel: "Voyage",
  dashboard_trucks: "Camions",
  dashboard_trucksWithTrailer: "Camion avec remorque",
  dashboard_type: "Type :",
  dashboard_uniqueEmployees: "Employés uniques",
  dashboard_unknown: "Inconnu :",
  dashboard_values: "Valeurs :",
  dashboard_vehicles: "Véhicules",
  dashboard_vehiclesOnSite: "Véhicules sur le site",
  dashboard_viewAll: "Voir tout",
  dashboard_waitTime: "Durée",
  dashboard_waitTime2: "Temps d'attente",
  dashboard_weeks: "semaine(s)",
  dashboard_withOcr: "avec OCR",
  dashboard_withPlate: "avec plaque",
  dashboard_withTrailer: "avec remorque",
  dashboard_wrong_detection: "Mauvaise détection",
  dashboard_yesterday: "Hier",
  dashboard_zone: "Zone :",
  dashboard_zones: "Zone(s)",
  dashboard_zones2: "Zone(s) :",
  default: "Par défaut",
  enabled_yes: "Enabled",
  enabled_no: "Not enabled",
  error_errorEncountered: "Une erreur est survenue",
  error_failedLoadData:
    "Impossible de charger les données de la base de données.",
  error_failedLoadProfile: "Impossible de charger le profil de l'utilisateur",
  error_failedLoadProfileData: "Impossible de charger le profil demandé.",
  error_failedToLoad: "Échec du chargement",
  error_failedToUpdateProfile: "Échec de mise à jour du profil.",
  events_active: "Actif",
  events_allEvents: "Tous les événements",
  events_createdBy: "Créé par",
  events_createdOn: "Créé le",
  inventory_placed: "Inventaire mis à jour",
  inventory_placed_with_sdel: "Inventaire mis à jour, SDEL complété",
  quantity: "Quantité : ",
  quantity2: "Quantité",
  save_changes: "Voulez-vous sauvegarder les changements?",
  manu_item_code: "Article du manufacturier",
  order_createdBy: "Créé par",
  order_createdOn: "Créé le",
  vendor_item_code: "No article fournisseur",
  vendor_code: "No article Fournisseur",
  jrv_welcome:
    "Bienvenue sur notre solution de gestion d'inventaire et d'approvisionnement.",
  jrv_welcome2:
    "NOTRE MISSION EST DE SIMPLIFIER ET D'OPTIMISER LA CHAȊNE D'APPROVISIONNEMENT DE NOS CLIENTS.",
  vendor_name: "Nom du fournisseur",
  vendor_num: "No article fournisseur",
  location_vmi: "Emplacement",
  fileSize_XL: "X-Large (>25 Mo)",
  fileSize_L: "Grand (>5 Mo à <25 Mo)",
  fileSize_M: "Moyen (>100 Ko à <5 Mo)",
  fileSize_S: "Petit (>5 Ko à <100 Ko)",
  fileSize_XS: "Petit (<100 Ko)",
  message: "Message",
  save_pzi:
    "Vous avez des changements non sauvegardés. Voulez-vous quitter sans sauvegarder?",
  unit_required:
    "Veuillez fournir les valeurs pour Profondeur, Largeur, Hauteur et Unité de mesure.",
  is_required: "est requis",
  jrv_code: "Code JRV",
  order_cancel:
    "Voulez-vous vraiment annuler? Une nouvelle commande avec ces quantités devra être créée.",
  order_cancel_error:
    "Comme le ou les produits sélectionnés sont les derniers à avoir le statut 'Confirme', ils ne peuvent pas être annulés alors que d'autres produits ont encore le statut 'En traitement'.",
  order_cancel_issue:
    "Une ou plusieurs lignes de produits sélectionnées n’ont pas été annulées[400 error list].",
  order_oreq_cancel: "Annuler des lignes",
  order_transmission: "Erreurs de transmission",
  retry_order_release: "Réessayer la libération",
  retry_order_release_confirm: "Voulez-vous continuer et réessayer la libération de cette commande?",
  retry_order_release_success: "La demande de libération a été envoyée.",
  retry_order_release_error: "Impossible de libérer cette commande",
  null_selection1: "ANNULER",
  null_selection2: "LIGNE(S) SÉLECTIONNÉE(S)",
  device_delete:
    "Voulez-vous vraiment supprimer cette périphérique? Cette opération est irréverisble.",
  replenishment_only: "Remplissage seulement",
  replenishment_automatic: "Remplissage automatique",
  replenishment_one_step: "Livraison et remplissage en une seul étape",
  order_in_progress_warning:
    "Au moins une commande ou demande est présentement associée à cet emplacement ou à un de ses sous-emplacements. Aucune modification de cet emplacement n’est donc permise.",
  replace_po_confirm: "Êtes-vous certain de vouloir remplacer ces POs ?",
  replace_po_confirm_singular:
    "Êtes-vous certain de vouloir remplacer ce PO ? ",
  replace_po_confirmed: "POs ont été remplacés.",
  replace_po_confirmed_singular: "PO a été remplacé.",
  wms_replace: "Remplacer",
  replace_for: "Remplacer par",
  sidebar_po_search: "Rechercher PO",
  current_inventory: "Inventaire actuel",
  resultsPerPage: "Résultats par page",
  lastUpdate: "Dernière mise à jour",
  sidebar_lookup: "Recherche produits",
  selected_vmi: "sélectionné(s)",
  binned: "Placée",
  ordered_quantity: "Quantité commandée",
  invalid_pzi: "Zone ID invalide",
  all_vmi: "Tous les VMI",
  total_to_come: "Total à venir",
  order_request_max_warning: "La valeur entrée excède le maximum",
  replenishment_en_route: "En route",
  replenishment_to_bin: "À placer",
  replenishment_delivered: "Livrée",
  replenishment_outstanding: "À traiter",
  replenishment_completed: "Complétée",
  replenishment_cancelled: "Annulée",
  wms_inventory: "Remplissage/Inventaire",
  sidebar_inventory: "Remplissage/Inventaire",
  product_errors: "produit(s) en erreur",
  resend_dialog:
    "Le ou les produits sélectionnés ont été renvoyés. S’il y a encore une erreur, veuillez réessayer plus tard.",
  remove_dialog_p1: "Voulez-vous vraiment supprimer les ",
  remove_dialog_p2: "produits sélectionnés de la commande?",
  remove_dialog_p3: "Les produits seront remis dans la demande.",
  order_remove: "Retirer",
  order_resend1: "Renvoyer",
  order_resend2: "produit(s)",
  scan_more: "Scanner un autre produit",
  table_associate: "Associé",
  search_results: "Résultats ",
  confirm_order: "Commande #",
  ogc_reference: "Référence OGC",
  vmi_with: "VMI avec demandes",
  vmi_without: "VMI sans demande",
  reset_fields: "Réinitialiser champs",
  total_quantity: "Quantité totale ",
  assisted_request: "Demande assistée",
  manual_request: "Demande manuelle",
  manufacturer: "Manufacturier",
  manufacturer_code: "Code du manufacturier",
  manufacturer_item_code: "Article du manufacturier",
  unit_of_measure: "Mesure de base",
  pending_order: "Commande en cours",
  last_order: "Dernière commande",
  product_on_list: "Produit déjà dans la liste",
  add_request: "Ajouter demande",
  ready_scan: "Prêt à scanner",
  qr_code_scan: "SCAN QR",
  sidebar_orders: "Demandes et commandes",
  state: "Etat",
  ref_external: "Réf. externe",
  sidebar_products: "Produits",
  selected_num: "sélectionnés",
  order_confirmation_1: "# Commande",
  order_confirmation_2: " créée avec succès.",
  order_submit: "Votre commande est en traitement.",
  events_end: "Fin",
  events_eventGroupId: "Identifiant du groupe d'événements",
  events_eventGroups: "Groupe d'événements",
  events_eventType: "Type d'événement",
  events_goToEventsPage: "Aller à la page Événements",
  events_id: "ID",
  zone_details: "Détails de la zone",
  label: "Étiquette",
  zone_delete:
    "Voulez-vous vraiment supprimer cette zone et toute son arborescence? Cette opération est irréverisble.",
  events_lieaDevice: "Périphérique LIEA",
  events_no: "Non",
  events_primaryAttributes: "Attributs principaux",
  events_profileMatch: "Correspondance de profil",
  events_profileTag: "Étiquette du profil",
  events_secondaryAttributes: "Attributs secondaires",
  events_site: "Site",
  events_start: "Début",
  events_tag: "Étiquette",
  events_yes: "Oui",
  events_zone: "Zone",
  footer_poweredBy: "Propulsé par",
  frdefinition_collection: "Nom de la collection",
  frdefinition_description: "Description",
  frdefinition_name: "Nom",
  Invalid_containerID_ISO6346:
    "ID de conteneur ISO 6346 non valide (10 ou 11 chiffres requis)",
  Invalid_container_size_and_type:
    "Code de ‘Taille et de Type’ (SATC) du conteneur non valide",
  Invalid_custom_Container_ID: "ID de conteneur personnalisé non valide",
  Invalid_Height:
    "Taille non valide (2d chiffre, attente: 0,2,4,5,6,8,9,C,D,E,F)",
  Invalid_Length:
    "Longueur non valide (1er chiffre, attente: 1,2,3,4,B,CG,H,LM,N)",
  Invalid_Width:
    "Largeur non valide (2e chiffre, attente: 0,2,4,5,6,8,9,C,D,E,F)",
  Invalid_Desc:
    "Description non valide (3e/4e chiffres, attente: 0-9, G,V,B,S,R,H,U,P,T,A)",
  Invalid_Category:
    "Catégorie non valide (3e/4e chiffres, attente: 0-9, G,V,B,S,R,H,U,P,T,A)",
  attributes_common: "Attributs communs",
  volume: "Volume",
  add_zone: "Ajouter Zone",
  frdefinition_provider: "Fournisseur reconnaissance faciale",
  label_printer_format_2x1: "2x1",
  label_printer_format_4x1: "4x1",
  label_printer_selection: "Sélectionner imprimante",
  label_which_printer:
    "Veuillez sélectionner l'imprimante qui contient les étiquettes de ",
  label_which_printer_2: " pouces.",
  label_printer_not_found:
    "Aucune imprimante trouvée. Veuillez connecter une imprimante et réessayer.",
  label_printer_error:
    "Erreur d'impression pour l'imprimante de l'étiquette de",
  label_printer_error_2: "pouces. Veuillez réessayer.",
  label_printer_bulk_bins: "Imprimer toutes les étiquettes des bins",
  label_printer_bulk_confirm:
    "Vous êtes sur le point d'imprimer {count} étiquette(s) au format {format} pour les bins de {zone}. Continuer ?",
  label_printer_bulk_empty:
    "Aucune étiquette de bin à imprimer pour ce niveau.",
  label_printer_bulk_error:
    "Impossible de récupérer les étiquettes des bins de ce niveau. Veuillez réessayer.",
  onsitecounts_warning:
    "Aucune adresse courriel n'est associée à votre profil. Veuillez associer une adresse courriel et réessayer.",
  onsitecounts_ok:
    "Vos rapports sont en train d'être générés et seront envoyés à ",
  onsitecounts_ok_end: " dès qu'ils seront prêts.",
  ordering_quantities: "Quantités de commande",
  eoq_title: "Quantité économique de commande (EOQ)",
  orders_base_unit: "Unité de base",
  product_state: "État",
  product_state_active: "Actif",
  product_state_blocked: "Bloqué",
  product_state_deleted: "Supprimé",
  product_state_obsolete: "Désuet",
  event_group_remove: "Êtes-vous sûr de vouloir supprimer cette détection ?",
  profile_remove:
    "Êtes-vous sûr de vouloir supprimer ce profil de l’événement ?",
  profiles_accepted: "Approuvé",
  profiles_active: "Actif",
  profiles_addAnother: "Ajouter un autre",
  profiles_addAnotherProfile: "Ajouter un autre profil",
  profiles_addAssociationTo: "Ajouter association à :",
  profiles_addPhotos: "Ajouter photo(s)",
  profiles_address1: "Adresse 1",
  profiles_answerGiven: "Réponse donnée",
  profiles_answers: "Réponses",
  profiles_archived: "Archivée(s)",
  profiles_archivedImages: "Photos archivées",
  profiles_archivedPolicies: "Documents de politique archivés",
  profiles_archivedSelectedPhotos: "Archiver les photos sélectionnées",
  profiles_assignedCompany: "Compagnie assignée",
  profiles_assignedSite: "Site assigné",
  profiles_assignedZone: "Zone assignée",
  profiles_assignmentWarningCompany:
    "Attention: ce profil n'est attribué à aucune compagnie. Souhaitez-vous continuer?",
  profiles_assignmentWarningSite:
    "Attention: ce profil n'est attribué à aucun site. Souhaitez-vous continuer?",
  profiles_associateThisProfileWithOtherProfiles:
    "Associer ce profil avec d'autres profils.",
  profiles_association: "Association",
  profiles_associations: "Associations",
  profiles_atLeastOneRequired: "Au moins un requis",
  profiles_attempt: "Essai",
  profiles_attempts: "essai(s)",
  profiles_attribute: "Attribut",
  profiles_barcode: "Code-barres",
  profiles_barcodeAlreadyInUse: "Code-barres déjà utilisé.",
  profiles_captured: "Photos captées",
  profiles_captured2: "Photos captées",
  profiles_carrier: "Transporteur",
  profiles_city: "Ville",
  profiles_color: "Couleur",
  profiles_comments: "Commentaires",
  profiles_company_id: "Compagnie assignée",
  profiles_compliance: "Conformité",
  profiles_complianceDeferral: "Délais de conformité",
  profiles_consent: "Consentement",
  profiles_containerProfile: "Profil du conteneur",
  profiles_containerProfile1: "Profil du conteneur 1",
  profiles_containerProfile2: "Profil du conteneur 2",
  profiles_containerType: "Type de conteneur",
  profiles_context: "Contexte",
  profiles_copyToContext: "Copier dans context",
  profiles_copyToIndexed: "Copier dans Indexée(s)",
  profiles_copyToUnindexed: "Copier dans Non indexée(s)",
  profiles_country: "Pays",
  profiles_covid19: "Covid-19",
  profiles_covidMsg1: "Merci",
  profiles_covidMsg2:
    "d'avoir pré-rempli le questionnaire. Par ce geste, vous contribuez à sauver des vies et à accélérer le processus de dépistage.",
  profiles_covidMsgClear: "Selon vos réponses, vous êtes autorisé à entrer.",
  profiles_covidMsgClear2: "Vous pouvez entrer",
  profiles_covidMsgWarning:
    "Selon vos réponses, vous pourriez être infecté par la Covid-19 et par conséquent, nous vous recommandons de rester à la maison. Notre personnel médical vous contactera sous peu.",
  profiles_covidMsgWarning2: "Allez voir le personnel médical.",
  profiles_createdBy: "Crée par",
  profiles_createdOn: "Crée le",
  profiles_croppedImage: "Image recadrée",
  profiles_currentlyLocatedIn: "Endroit actuel :",
  profiles_currentProfile: "Profil actuel",
  profiles_d: "jour(s)",
  profiles_dacId: "Identifiant DAC",
  profiles_dataPolicy: "Politique de données",
  profiles_dataPolicyLongMsg:
    "Vous avez décidé de ne pas aviser la personne une fois inscrite pour obtenir son consentement.  Vous aviez peut-être déjà obtenu son consentement séparément, c'est pourquoi vous avez choisi de sauter cette étape.  Veuillez vous assurer de ne violer aucune politique de l'entreprise. En cas de doute, nous vous recommandons d'enregistrer le profil sans l'inscrire et de contacter la personne responsable pour connaître les prochaines étapes.",
  profiles_dataPolicyNotify:
    "Une fois inscrite, avertissez la personne de lire la politique de donnés pour obtenir son consentement.",
  profiles_dataPrivacy: "Politiques utilisateur",
  profiles_dataPrivacyText:
    "Veuillez lire chaque document ci-dessous et indiquer si vous donnez votre consentement ou non.",
  profiles_dateCompleted: "Date/Heure de fin",
  profiles_dateTime: "Date et heure",
  profiles_deleteProfile: "Supprimer le profil",
  profiles_deleteWarning: "Voulez-vous vraiment supprimer le profil?",
  profiles_description: "Description",
  profiles_deselectAll: " Sélectionner tout",
  profiles_details: "Détails",
  profiles_detectionId: "Détection",
  profiles_deviceName: "Nom du périphérique",
  profiles_digest: "Condensé (digest)",
  profiles_downloadCsv: "Télécharger en CSV",
  profiles_downloadPdf: "Télécharger PDF",
  profiles_driver: "Conducteur",
  profiles_driverLicense: "Permis de conduire",
  profiles_elprConfidenceIndex: "Indice de confiance ELPR",
  profiles_elprMatchesTemplates: "Modèles de correspondances ELPR",
  profiles_email: "Courriel",
  profiles_emailAlreadyInUse: "Courriel déjà utilisé.",
  profiles_employeeId: "ID de l'employé",
  profiles_employer: "Employeur",
  profiles_end: "Fin",
  profiles_enroll: "Inscrire",
  profiles_enrolling: "Inscription du profil",
  profiles_enrollSelectedPhotos:
    "Inscrire le profil avec la (les) photo(s) sélectionnée(s) (indexées)",
  profiles_entrance: "Entrée :",
  profiles_entryStatus: "Autorisation",
  profiles_error: "Erreur",
  profiles_eventGroupId: "Identifiant du groupe d'événements",
  profiles_eventId: "Identifiant d'événement",
  profiles_events: "Événements",
  profiles_eventType: "Type d'événement",
  profiles_eventVersion: "Version d'événement",
  profiles_exit: "Sortie :",
  profiles_fail: "Échec",
  profiles_failed: "Échec",
  profiles_failedImages: "Échec d'affichage des photos",
  profiles_firstName: "Prénom",
  profiles_formatInvalid: "Format invalide",
  profiles_fullContextImage: "Image contextuelle complète",
  profiles_goToFullProfile: "Aller au profil complet",
  profiles_goToProfile: "Aller au profil",
  profiles_groupView: "Vue groupée",
  profiles_hideArchived: "Masquer Archivée(s)",
  profiles_historicRecordsTitle:
    "Entrées trouvées sur l'historique d'enregistrement entrée/sortiee DAC (contrôle d'accès à la distribution)",
  profiles_historyLog: "Journal de l'historique",
  profiles_historyView: "Vue chronologique",
  profiles_humanProfile: "Profil Humain",
  profiles_iAccept: "J'approuve",
  profiles_iConfirm: "Je confirme",
  profiles_iHaveRead: "J’ai lu ce document.",
  profiles_images: "Photos",
  profiles_inactive: "Inactif",
  profiles_indexed: "Indexée(s)",
  profiles_indexedImages: "Photo(s) indexée(s)",
  profiles_indexingPhotosInProgress: "Indexation de photos en cours",
  profiles_indexWarning:
    "Les photos sélectionnées peuvent apparaître dans la section Non indéxée(s) si l'indexation est en cours. Selon le nombre de photos sélectionnées, le temps d'indexation peut être long. Veuillez rafraîchir la page ou revenez-y plus tard pour voir l'état final de l'indexation (Indexée(s) ou Échec).",
  profiles_individuals: "Personnes",
  profiles_iRefuse: "Je refuse",
  profiles_is: "Est",
  profiles_language: "Langue",
  profiles_lastName: "Nom",
  profiles_left: "restant",
  profiles_licensePlate: "Plaque d'immatriculation",
  profiles_licensePlateOrOcr:
    "Un numéro de plaque d'immatriculation OU au moins une entrée OCR sélectionnée est requise.",
  profiles_lieaDeviceId: "Identifiant périphérique LIEA",
  profiles_lieaLprVersion: "Version LPR LIEA",
  profiles_lieaMacAddress: "Adresse Mac LIEA ",
  profiles_lieaTimestamp: "Horodatage LIEA",
  profiles_loadMore: "Afficher plus",
  profiles_localStorage: "Emplacement de stockage local",
  profiles_location: "Endroit",
  profiles_location2: "Zone",
  profiles_logEntries: "Nombre d'entrées",
  profiles_logType: "Type d'activité",
  profiles_lprAlreadyExists:
    "Numéro de plaque d'immatriculation déjà existant dans un autre profil.",
  profiles_lprHistoricRecords:
    "entrées de profil inconnu ayant cette plaque d'immatriculation.",
  profiles_main: "Principal",
  profiles_make: "Marque",
  profiles_model: "Modèle",
  profiles_modifiedOn: "Traité le",
  profiles_name: "Nom",
  profiles_newProfile: "Nouveau profil",
  profiles_no: "Non",
  profiles_noResultsFound: "Aucun résultat",
  profiles_note: "Note",
  profiles_notes: "Notes",
  profiles_notOnSite: "Hors site",
  profiles_objects: "Objets",
  profiles_ocrAlreadyExists: "OCR déjà existant dans un autre profil.",
  profiles_ocrHistoricRecords1: "entrées de profil inconnus ayant",
  profiles_ocrHistoricRecords2: "entrées OCR uniques.",
  profiles_ocrValues: "Entrées OCR",
  profiles_online: "En ligne",
  profiles_onSite: "Sur place",
  profiles_optional: "Optionnel",
  profiles_other: "Autre",
  resent:
    "Un lien de validation a été envoyé à votre adresse e-mail. Veuillez cliquer sur le lien pour activer votre compte.",
  profiles_ownerCompanyId: "Id compagnie propriétaire",
  profiles_ownerProfileId: "Id profil propriétaire",
  profiles_parentEventId: "Identifiant d'événement parent",
  profiles_pass: "Ok",
  profiles_passengerProfile: "Profil Passager",
  profiles_password: "Mot de passe",
  profiles_passwordExpiration: "Expiration du mot de passe",
  profiles_pending: "En attente",
  profiles_pendingConsent: "Consentement en attente",
  profiles_period: "Période",
  profiles_phoneAlreadyInUse: "Numéro de téléphone déjà utilisé.",
  profiles_phoneNumber: "Numéro de téléphone",
  number2: "Nombre",
  profiles_photo: "Photo",
  empty: "Vide",
  loaded: "Chargé",
  create_another: "Créer un autre",
  select_time_date: "SÉLECTIONNER ZONE",
  avail_time: "Plages Horaires Disponibles",
  spec_time: "Temps Spécifique",
  date_time: "La Date",
  file: "Déposer",
  time_zone: "Fuseau",
  profiles_photos: "Photos",
  role: "Filtre",
  mdc_timeline: "Chronologie",
  what_to: "Quoi faire ",
  ref: "Ref #",
  activity: "Activity",
  status: "État",
  reqtime: "Requested Date/Time",
  PO: "PO",
  carrier: "Carrier",
  assigned_driver: "Assigned Driver",
  assigned_vehicle: "Assigned Vehicle",
  trailer: "Trailer/Container",
  zone_door: "Zone/Door",
  yard_visit: "Visite De La Cour",
  in_yard: "Dans la Cour",
  person_visit: "Visite de Personne",
  mdc_list: "Liste",
  drop: "Tomber",
  pickup: "Récupérer",
  number: "Numéro",
  file2: "Déposer",
  name_reservation: "Nom de la Réservation",
  color_reservation: "Couleur de Réservation",
  instructions: "Instructions",
  allowed_time_before: "Temps Autorisé Avant",
  allowed_time_after: "Temps Autorisé Après",
  activity_duration: "Durée de L'Activité",
  arrival: "Arrivée",
  departure: "Départ",
  switch: "Changer",
  drag_drop: "(ou glissez-déposez les fichiers ici)",
  content_description: "Description du Contenu",
  liveload: "Charge en direct",
  liveunload: "Déchargement en Direct",
  miscellaneous: "Miscellaneous",
  reservation: "Réservation",
  newvisit: "VISITE DE COUR - NOUVELLE RÉSERVATION",
  activities: "Activités",
  summary: "Sommaire",
  move: "Mouvement",
  load: "Charge",
  unload: "Décharger",
  profiles_photosAreRequiredToEnrollHumanProfiles:
    "Des photos sont nécessaires pour inscrire et identifier les profils de personnes.",
  profiles_photosCanBeAddedLater:
    "Les photos peuvent être ajoutées ultérieurement.",
  profiles_photosSaved:
    "photo(s) ajoutée(s) sous l'onglet Photos de la page Profil.",
  profiles_pleaseConfirmRead:
    "Veuillez confirmer que vous avez lu ce document.",
  profiles_policyAlertDenied:
    "Certaines politiques doivent être acceptées avant de pouvoir utiliser le logiciel",
  profiles_policyAlertWarning:
    "Certaines politiques sont en attente de consentement.",
  profiles_policyDocument: "Document de politique",
  profiles_policyNotFound: "Politique non trouvée",
  profiles_policyType: "Type de politique",
  profiles_postalCode: "Code postal",
  profiles_preferedLanguage: "Langue de préférence",
  profiles_preferedModeOfCommunication: "Mode de communication de préférence",
  profiles_privateUserData: "Données privées de l'utilisateur",
  profiles_proceedWithEnrollment: "Procéder avec l'inscription",
  profiles_processedBy: "Traité par",
  profiles_profile: "Profil",
  profiles_profileCreated: "Profil créé avec succès !",
  profiles_profileCreatedButNotEnrolled:
    "Profil créé avec succès mais pas inscrit.",
  profiles_profileEnrolled: "Profil inscrit avec succès !",
  profiles_profileEnrollmentFailed: "Profil non inscrit.",
  profiles_profileGlobalSearch: "Recherche globale de profils",
  profiles_profileName: "Nom du profil",
  profiles_profilePhoto: "Photo du profil",
  profiles_profileSaved: "Profil sauvegardé avec succès !",
  profiles_profileType: "Type de profil",
  vmi_requests: "Demandes",
  vmi_orders: "Commandes",
  profiles_profileTypes: "Types de profil",
  profiles_publishedDate: "Date de publication",
  profiles_questionnaire: "Questionnaire",
  profiles_questions: "Questions",
  profiles_read: "Lu",
  profiles_referenceEventId: "Numéro d’événement de référence",
  profiles_refused: "Refusé",
  profiles_remote: "à distance",
  profiles_required: "Exigé",
  profiles_requiredNow: "Exigé maintenant",
  profiles_results: "Résultats",
  profiles_resultsInstructions: "Résultats/Instructions",
  profiles_rfid: "RFID",
  profiles_rfidAlreadyInUse: "RFID déjà utilisé.",
  profiles_riskLevel: "Niveau de risque",
  profiles_roles: "Rôle(s)",
  profiles_saveWithoutEnrolling: "Sauvegarder sans inscrire",
  profiles_saving: "Enregistrement en cours",
  profiles_savingPhotos: "Sauvegarde des photos",
  profiles_searchProfile: "Rechercher un profil",
  profiles_searchProfileToAdd: "Chercher le profil à ajouter",
  profiles_secondary: "Secondaire",
  profiles_selectAll: "Sélectionner tout",
  profiles_selectDocumentInTheTable:
    "Veuillez sélectionner un document de politique dans le tableau de gauche.",
  profiles_selectProfileTypeToAdd: "Sélectionner le profil à ajouter",
  profiles_selectQuestionnaire: "Sélectionnez le questionnaire",
  profiles_showArchived: "Afficher Archivée(s)",
  profiles_site: "Site",
  profiles_sites: "Sites",
  profiles_siteZone: "Site/Zone",
  profiles_skip: "Passer",
  profiles_skipped: "Passé",
  profiles_start: "Début",
  profiles_stateProvince: "État/Province",
  profiles_stats: "Statistiques",
  profiles_status: "Statut",
  profiles_stringFound: "Texte trouvé",
  profiles_submittedOn: "Soumis le",
  profiles_survey: "Questionnaire",
  profiles_surveyId: "ID du questionnaire",
  profiles_tag: "Étiquette",
  profiles_tags: "Étiquettes",
  profiles_tailgate: "Talonnage",
  profiles_toAddPhotosGoToTab:
    "Pour ajouter/supprimer des photos, accédez à l'onglet Photos sur la page Profil.",
  profiles_toRead: "À lire",
  profiles_total: "Total :",
  profiles_trailerProfile: "Profil Remorque",
  profiles_trailerProfile1: "Profil Remorque 1",
  profiles_trailerProfile2: "Profil Remorque 2",
  profiles_trailerType: "Type de remorque",
  profiles_type: "Type",
  profiles_unindexed: "Non indexée(s)",
  profiles_unindexedImages: "Photos non indexées",
  profiles_unindexSelectedPhotos:
    "Annuler l'indexation des photos sélectionnées",
  profiles_username: "Nom d'utilisateur",
  profiles_userRole: "Rôle Usager",
  profiles_vehicle: "Véhicule",
  profiles_vehicleProfile: "Profil Véhicule",
  profiles_vehicleType: "Type de véhicule",
  profiles_verification: "Vérification",
  profiles_version: "Version",
  profiles_viewEventGroup: "Afficher le groupe d'événements",
  profiles_vin: "NIV",
  profiles_w: "semaine(s)",
  profiles_warningHistoricRecords1:
    "La création de ce profil remplacera celui existant",
  profiles_warningHistoricRecords2: "Enregistrer ce profil.",
  profiles_year: "Année",
  profiles_yes: "Oui",
  profiles_yesAnswers: 'Réponses "Oui"',
  profiles_zone: "Zone",
  profiles_zoneTypes: "Type de zone",
  pzi_open_order: "Commande en cours",
  pzi_units_edit_instructions:
    "Sélectionnez les quantités que vous voulez voir affichées dans la fenêtre de commande de ce produit.",
  pzi_units_view_instructions:
    "Les quantités de commande marquées d'un crochet vert sont affichées dans l'écran de commande de ce produit.",
  pzi_units_will_be_displayed: "Sera affiché",
  reference_code: "Code de référence",
  scheduler_addVisitor: "Ajouter visiteur",
  scheduler_after: "Après",
  scheduler_appointements: "Hôtes",
  scheduler_days: "jour(s)",
  scheduler_daysStartingOn: "jours débutant le ",
  scheduler_deactivateConfirm: "Supprimer...",
  scheduler_deleteConfirm: "Voulez-vous vraiment supprimer cette occurrence?",
  scheduler_doesNotRepeat: "Ne se répète pas ",
  scheduler_repeat: "Répète...",
  scheduler_ends: "Se termine",
  next: "Suivant",
  signUp: "Se créer un compte",
  scheduler_endTime: "Heure fin ",
  scheduler_every: "Chaque",
  scheduler_exceptions: "Exceptions",
  scheduler_host: "Hôte",
  scheduler_hosts: "Hôtes",
  scheduler_months: "mois",
  scheduler_newSchedulerOccurrence: "Nouvelle occurrence",
  scheduler_occurrences: "occurrences",
  scheduler_ofTheMonth: "du mois",
  scheduler_on: "Le",
  scheduler_perDayOnAPeriodOf: "par jour sur une période de ",
  scheduler_perTimeSlot: "par plage horaire :",
  scheduler_recurrenceCustom: "Récurrence - Personnalisée",
  scheduler_repeatDaily: "Se répète chaque jour",
  scheduler_repeatDaily2: "Chaque jour",
  scheduler_repeatMonthly: "Se répète chaque mois",
  scheduler_repeatMonthly2: "Chaque mois",
  scheduler_repeats: "Se répète",
  scheduler_repeatsEvery: "Se répète chaque",
  scheduler_repeatWeekly: "Se répète chaque semaine",
  scheduler_repeatWeekly2: "Chaque semaine",
  scheduler_repeatYearly: "Se répète chaque année",
  scheduler_repeatYearly2: "Chaque année",
  scheduler_scheduler: "Planificateur",
  scheduler_schedulerOccurrence: "Occurrence",
  scheduler_schedulerSettings: "Paramètres - Planificateur ",
  scheduler_scheduleType: "Type d’horaire ",
  scheduler_searchHost: "Chercher hôte",
  scheduler_searchVisitor: "Rechercher visiteur",
  scheduler_showCustomTimeSlots:
    "Afficher les plages horaires personnalisées (per.)",
  scheduler_siteVisitsAllowed: "Visites permises sur le site :",
  scheduler_starting: "débutant",
  scheduler_startTime: "Heure début",
  scheduler_timeSlot: "plage horaire",
  scheduler_timeSlots: "Plages horaires",
  scheduler_timeSlotsMustNotOverlap:
    "Les plages horaires ne doivent pas se superposer.",
  scheduler_unknownVisitor: "Visiteur inconnu ",
  scheduler_visitors: "Visiteur(s)",
  scheduler_visitors2: "Visiteurs",
  scheduler_visitorsAllowedPer: "Visiteurs permis par ",
  scheduler_visitRestrictions: "Restrictions des visites",
  scheduler_use_same_driver_vehicle:
    "Même conducteur/véhicule qu’à l'$ACTIVITY_VARIABLE_NAME",
  scheduler_name_reservation: "Nom de la Réservation",
  scheduler_datepicker_label: "Date",
  scheduler_datepicker_start_date: "Date de début",
  scheduler_datepicker_end_date: "Date de fin",
  scheduler_instructions: "Instruction",
  scheduler_instructions_language: "Language",
  scheduler_allowed_time_before: "Temps Autorisé Avant",
  scheduler_allowed_time_after: "Temps Autorisé Après",
  scheduler_allowed_time_before_after: "Temps de Tolérance",
  scheduler_profiles: "Profils",
  scheduler_zone_door: "Zone",
  scheduler_activities: "Activities",
  scheduler_activity_type: "Type d’activité",
  scheduler_documents: "Documents",
  scheduler_schedule_color: "Reservation Color",
  scheduler_currently_expected: "Actuellement prévu",
  scheduler_requiring_attention: "Demande attention",
  scheduler_deactivation_warning:
    "Voulez-vous vraiment supprimer cette occurrence?",
  scheduler_schedule_id: "Horaire ID",
  scheduler_schedule_Direct_link: "View Schedule in New Tab",
  scheduler_view_event_group_lable: "View Event Group",
  sidebar_admin: "Admin & Config",
  sidebar_aiService: "Service AI",
  sidebar_alerts: "Alertes",
  sidebar_analytics: "Analyses",
  sidebar_barcode: "Code-barres",
  sidebar_businessRules: "Règles d'affaires",
  sidebar_companies: "Compagnies, sites, zones et périphériques",
  sidebar_companiesSitesZones: "Compagnies, sites et zones",
  sidebar_config: "Configuration",
  sidebar_dashboard: "Tableau de bord",
  sidebar_dashboards: "Tableaux de bord et rapports",
  sidebar_dashboards2: "Tableaux de bord ",
  sidebar_devices: "Périphériques",
  sidebar_driveIn: "Entrée véhicules",
  sidebar_driveOut: "Sortie véhicules",
  sidebar_events: "Événements système",
  sidebar_faceid: "ID visage",
  sidebar_general: "Général",
  sidebar_hsp: "HSP (détection santé et sécurité)",
  sidebar_HSP: "HSP",
  sidebar_hspCurrentStatusDashboard:
    "Tableau de bord HSP principal (État actuel)",
  sidebar_hspDashboard: "Tableau de bord HSP principal",
  sidebar_hspOriginalStatusDashboard:
    "Tableau de bord HSP principal (État original)",
  sidebar_humanAccess: "Accès humains",
  sidebar_IDP: "IDP",
  sidebar_indexSettings: "Paramètres d'index",
  sidebar_liveView: "Vue en direct",
  sidebar_mdc: "RSV (Visibilité des Expéditions Routières)",
  sidebar_carriers: "Transporteurs",
  carrier_name: "Nom du transporteur",
  sidebar_MDC: "RSV",
  sidebar_mdcDashboard1: "RSV Tableau de bord Entrée/Sortie",
  sidebar_mdcDashboard2: "RSV Tableau de bord principal",
  sidebar_mdc: "MDC (centres manufacturiers et de distribution)",
  sidebar_MDC: "MDC",
  sidebar_mdcDashboard1: "Tableau de bord MDC entrées/sorties véhicules",
  sidebar_mdcDashboard2: "Tableau de bord MDC principal",
  sidebar_me: "Moi",
  sidebar_MSP: "MSP",
  sidebar_mspMonthlyTransactionalStats:
    "Statistiques mensuelles sur les transactions MSP",
  sidebar_onsiteCounts: "Nombre de profils sur site(s)",
  sidebar_companyCounts: "Nombre de profils de companie",
  sidebar_peopleCountDashboard: "Tableau de bord du nombre de personnes",
  sidebar_profiles: "Profils",
  sidebar_scheduler: "Planificateur",
  sidebar_search: "Rechercher",
  sidebar_siteAndZones: "Sites et zones",
  sidebar_siteEntranceExit: "Entrée/Sortie site",
  sidebar_statistics: "Statistiques",
  sidebar_tags: "Étiquettes",
  sidebar_upcomingEvents: "Événements à venir",
  sidebar_users: "Utilisateurs et rôles",
  sidebar_vehicleAccess: "Accès véhicules",
  sidebar_vehicleHumanAccess: "Accès véhicules et humains (en direct)",
  sidebar_walkInNew: "Entrée humains (Express)",
  sidebar_walkOutNew: "Sortie humains (Express)",
  site_aboutToChange: "Vous êtes sur le point de changer de :",
  site_active: "Actif",
  site_activityDetected: "Activité détectée...",
  site_add: "Ajouter",
  site_addComment: "Ajouter commentaire",
  site_addNotes: "Ajouter notes",
  site_address1: "Adresse 1",
  site_address2: "Adresse 2",
  site_all: "Tout",
  site_allow: "Autoriser",
  site_allowAccess: "Permettre l'accès",
  site_apply: "Appliquer",
  site_archivedTemperatures: "Températures archivées",
  site_atDoor: "À la porte",
  site_atGate: "À la barrière",
  site_average: "Moyenne",
  site_avg: "Moy",
  site_avgTemp: "Temp. moy.",
  site_back: "Retour",
  site_barcode: "Code-barres",
  site_blackbodyOffset: "Déviation Blackbody",
  site_blackbodyRawValue: "Valeur brute Blackbody",
  site_blackbodyState: "État Blackbody",
  site_blank: "Vide",
  site_body: "Corps",
  site_bodyTemp: "Température du corps",
  site_bol: "# BOL",
  site_browse: "Parcourir...",
  site_by: "par",
  site_byPhoto: "Par photo",
  site_byProfile: "Par profil",
  site_byProfileType: "Par type de profil",
  site_cameraMesuredTemp: "Températures mesurées",
  site_cancel: "Annuler",
  site_captured: "Capté",
  site_capturedPhotos: "Photo(s) captée(s) importante(s)",
  site_capturedPhotos2: "Photos captées",
  site_capturedPhotosFrResults:
    "Photo(s) captée(s) et résultats reconnaissance faciale",
  site_capturedTemperatures: "Mesures de température",
  site_carrier: "Transporteur",
  site_carrier2: "Trans.",
  site_carrierRequired: "Transporteur obligatoire.",
  site_changed: "Changé",
  site_chrono: "Chrono",
  site_chronoFormat: "(mm:ss)",
  site_city: "Ville",
  site_clearingIn: "Réinitialisation dans :",
  site_close: "Fermer",
  view_order: "VOIR LES COMMANDES",
  cardMsg: "(Sera votre nom d'utilisateur)",
  successValid: "Votre compte a été active avec succès",
  successValid2: "Votre compte a déjà été activé.",
  successValid3: "Vous pouvez vous connecter.",
  linkExpired1: "Ce lien d’activation est expiré. Pour en obtenir",
  linkExpired2: "un nouveau, veuillez sur Envoyer de nouveau.",
  notyetActivated1: "Ce compte n’est pas encore activé. Veuillez cliquer",
  notyetActivated2: "sur le lien d’activation qui vous a été envoyé,",
  notyetActivated3: "ou cliquer sur renvoyer pour en obtenir un nouveau.",
  resend: "Envoyer de nouveau",
  signInBtn: "SE CONNECTER",
  site_closePhotoWindowWarning1:
    "La création d'un nouveau profil fermera la fenêtre de photo.",
  site_closePhotoWindowWarning2: "Souhaitez-vous continuer?",
  site_comment: "Commentaire",
  site_comments: "Commentaires",
  site_company: "Compagnie",
  site_confirm: "Confirmer",
  site_container: "Conteneur",
  site_container1: "Conteneur 1",
  create_zone: "ZONE(S)",
  site_container2: "Conteneur 2",
  site_content: "Contenu",
  site_context_lpr: "Contexte (LPR)",
  site_context_ocr: "Contexte (OCR)",
  site_context: "Contexte (Détection)",
  site_contextPhoto: "Contexte de la photo",
  site_contextPhotos: "Photo(s) contexte",
  site_correct: "Correct",
  site_correction: "Correction",
  site_country: "Pays",
  site_create: "Créer",
  site_createAnother: "Créer un autre",
  site_createdByOn: "Créé par/le",
  site_createProfile: "Créer profil",
  site_createVehicleProfile: "Créer le profil du véhicule",
  site_creating: "En cours de création",
  site_creatingProfile: "Création d'un profil",
  site_cropped: "Rognée",
  site_currentConfiguration: "Configuration actuelle",
  site_currentDateTime: "Date et heure actuelles",
  site_currentEventLog: "Entrée de journal courante",
  site_currentProfile: "Profil courant :",
  site_currentState: "État actuel :",
  site_dateOverRange: "La période sélectionnée ne peut pas dépasser",
  site_dateTime: "Date et heure",
  site_deny: "Refuser",
  site_denyAccess: "Refuser l'accès",
  site_department: "Départment",
  site_description: "Description",
  site_details: "Détails",
  site_detected: "Détecté",
  site_device: "Périphérique",
  site_dimensions: "Dimensions",
  site_displayedCovidQuestionnaire: "Questionnaire COVID-19 affiché",
  site_doYouWantToUpdateLocation: "Voulez-vous mettre à jour l'emplacement?",
  site_driveInDriveOut: "Entrée/Sortie camion",
  site_driveInOut: "Accès véhicules",
  site_driver: "Humain",
  site_driver2: "Conducteur",
  site_driverFirstName: "Prénom conducteur",
  site_driverLastName: "Nom conducteur",
  site_driverLicense: "Permis de conduire",
  site_duration: "Durée :",
  duration: "Durée de l'événement",
  site_elapsed: "Temps écoulé :",
  site_email: "Courriel",
  site_employeeId: "ID employé",
  site_employeesCard: "Carte d'employé",
  site_employeesCardOf: "Carte d'employé de :",
  site_employer: "Employeur",
  site_endDate: "Date de fin",
  site_entry: "Entrée",
  site_entryStatus: "Autorisation",
  site_eventDetails: "Détails événement",
  site_eventGroup: "Groupe d'événements",
  site_eventGroupId: "Id groupe d'événement :",
  site_events: "Événements",
  site_exit: "Sortie",
  site_eyesVisible: "Yeux visibles",
  site_face_detect: "Détection visage",
  site_face: "Visage",
  site_faceMatch: "Correspondance visage",
  site_failedToCreateProfile: "Impossible de créer le profil.",
  site_fileName: "Nom de fichier",
  site_fileSize: "Taille du fichier",
  site_fileType: "Type de fichier",
  site_filterDate: "Filtre sur plage de dates",
  site_filterDateText:
    "Veuillez sélectionner une plage de dates pour filtrer les données.",
  site_finalTemperature: "Température finale",
  site_firstName: "Prénom",
  site_firstNameRequired: "Prénom obligatoire.",
  site_found: "Trouvé",
  site_frConfiguration: "Configuration reconnaissance faciale",
  site_frDefinition: "Définition reconnaissance faciale",
  site_frEnroll: "Inscrire (Reconnaissance faciale)",
  site_fuelLevel: "Niveau de carburant",
  site_goToEventGroup: "Aller au groupe d'événements",
  site_goToFullProfile: "Accéder au profil complet",
  site_hide: "Masquer",
  site_hideAdditionalColumns: "Masquer colonnes additionnelles",
  site_hideRoi: "Masquer le ROI",
  site_highestScoreMatch: "Correspondance avec score le plus élevé :",
  site_highestScoreProfile: "Profil avec score le plus élevé",
  site_historic: "Historique",
  site_historicSiteentry: "Historique des entrées au site",
  site_historicSiteexit: "Historique des sorties du site",
  site_historyEvents: "Événements (historique)",
  site_human_detect: "Détection humain",
  site_human_exit: "Sortie humain",
  site_human: "Humain",
  site_humanAccess: "Accès humains",
  site_humanDetected: "Humain détecté",
  site_identified: "Identifié",
  site_indexedPhotos: "Photo(s) indexée(s)",
  site_inPercent: "(en %)",
  site_internalUse: "(utilisation interne)",
  site_iso: "ISO",
  site_isoTemp: "Température ISO",
  site_isTheCorrect: "Est-ce la bonne",
  site_itemToVerify: "Élements à vérifier",
  site_kioskAvgTemp: "Temp. moy. (Kiosque) ",
  site_kioskMaxTemp: "Temp. max. (Kiosque)",
  site_kioskMinTemp: "Temp. min. (Kiosque)",
  site_last: "Dernier",
  site_lastModified: "Dernière modification",
  site_lastName: "Nom",
  site_lastNameRequired: "Nom de famille obligatoire.",
  site_lastVerification: "Dernière vérification",
  site_licensePlate: "Plaque d'immatriculation",
  site_licensePlateRecognition: "Reconnaissance de la plaque d'immatriculation",
  site_loaded: "Chargé",
  site_loadingData: "Chargement de données",
  site_loadMore: "Charger +10",
  site_locationUpdate: "Emplacement mis à jour",
  site_log: "Journal",
  site_logEntryRef: "# référence d'entrée au journal ",
  site_logs: "Journaux",
  site_logType: "Type d'activité",
  site_lpr: "LPR",
  site_lprMatch: "Correspondance LPR",
  site_main: "Résumé",
  site_main2: "Principal",
  site_rented: "Loué",
  site_level: "Niveau",
  site_position: "Position",
  site_row: "Rangée",
  site_client: "Client",
  site_billing_note: "Note de Facturation",
  site_mainDetails: "Détails principaux",
  site_make: "Marque",
  site_manualTemp: "Corps (Manuelle)",
  site_manualTemp2: "Temp. manuelle",
  site_manualTemperature: "Température manuelle",
  site_mask: "Port du masque?",
  site_match: "Trouvé",
  site_matchedProfile: "Profil trouvé",
  site_matches: "Correspondances",
  site_matchSuccess: "Taux de succès de correspondance",
  site_max: "Max",
  site_maximum: "Maximum",
  site_maxTemp: "Temp. max.",
  site_measure: "Température mesurée",
  site_measuredTemp: "Température mesurée",
  site_measureType: "Type de mesure",
  site_metadata: "Métadonnées",
  site_min: "Min",
  site_minimum: "Minimum",
  site_minTemp: "Temp. min.",
  site_model: "Modèle",
  site_modifiedOn: "Traité le",
  site_monitorTab: "Sélectionnez une zone à surveiller dans un nouvel onglet.",
  site_more: "plus",
  site_moveMouseOverImage:
    "Passer la souris sur l'image pour voir les mesures de température. ",
  site_name: "Nom",
  site_nameRequired: "Nom obligatoire.",
  site_newCovidQuestionnaire: "Nouveau questionnaire COVID-19",
  site_newEntry: "Nouvelle entrée",
  site_newTemperature: "Nouvelle température",
  site_no: "Non",
  site_no_po: "Aucun PO",
  zone_parent: "Zone parent: ",
  zone_error:
    "Le type de zone que vous voulez créer ne peut être créé sous cette zone parent.",
  site_noCarrier: "Sans transporteur",
  site_noChanges: "Non changé",
  site_noData: "Pas de données disponibles.",
  site_noEntryFound: "Aucune entrée trouvée dans la zone sélectionnée.",
  site_noHumanDetected: "Aucun humain détecté.",
  site_noLPR: "Aucune reconnaissance de plaque d'immatriculation disponible.",
  site_noMatch: "Aucune correspondance",
  site_noMatchedProfileFound: "Pas de correspondance trouvée.",
  site_none: "Aucun",
  site_noneAboveCreateProfile: "Aucun des choix. Créer un profil.",
  site_noOCR: "Aucune reconnaissance optique de caractères disponible.",
  site_noPhoto: "Pas de photo",
  site_noPhotoFound: "Aucune photo trouvée.",
  site_noProfileFound: "Aucun profil trouvé.",
  site_noProfileMatch: "La détection ne correspond à aucun profil.",
  site_noProfileMsg: "Profil inexistant. Créer un profil.",
  site_noProfileMsg2:
    "Aucun profil trouvé avec les valeurs LPR/OCR ci-dessus. Créez un nouveau profil.",
  site_noQuestionnaireCreated: "Aucun questionnaire n'a été créé.",
  site_noQuestionnaireFound: "Aucun questionnaire trouvé.",
  site_noSite: "Sans site",
  site_noTag: "Sans étiquette",
  site_noteAbout: "Note sur :",
  site_noteType: "Type",
  site_General: "Général",
  site_CompareResults: "Comparer les résultats",
  site_InspectionSafety: "Contrôle / Sécurité",
  site_noTemperatureReading:
    "Aucune mesure de température pour l'entrée de journal courante.",
  site_notes: "Notes",
  site_notFound: "Non trouvé",
  site_notLast: "pas le dernier",
  site_noTrailerDetected: "Aucune remorque détectée.",
  site_noVehicleAtGate: "Aucun véhicule à la barrière",
  site_noVehicleDetected: "Aucun véhicule détecté.",
  site_ocr: "OCR",
  site_ocrMatch: "Correspondance OCR",
  site_ocrValues: "Entrées OCR",
  site_ocrValuesMsg: "Les entrées sélectionnées sont uniques à ce profil.",
  site_odometer: "Odomètre",
  site_ok: "Ok",
  site_opticalCharacterRecognition: "Reconnaissance optique de caractères",
  site_otherProfilesFound: "Profils potentiels trouvés",
  site_override: "Remplacer",
  site_overrideMsg: "Remplacer profil actuel",
  site_overridenBy: "Remplacé par :",
  site_overridingProfile: "Remplacement en cours",
  site_parentZone: "Zone parent",
  site_passenger: "Passager",
  site_pastDateTime: "Date et heure passées",
  site_pastEntries: "Entrées antérieures",
  site_phoneNumber: "Numéro de téléphone",
  site_photos: "Photo(s)",
  site_photosMessage:
    "Les photos cochées seront indexées. Les photos non cochées seront conservées mais pas indexées.",
  site_pleaseFillRequiredFields:
    "Veuillez remplir tous les champs obligatoires.",
  site_pleaseProvideLprOrOcr:
    "Veuillez fournir une plaque d'immatriculation ou au moins une valeur OCR unique.",
  site_pleaseSelectSite: "Veuillez sélectionner un site.",
  site_pleaseSelectZone: "Veuillez sélectionner une zone.",
  site_po: "PO #",
  site_postalCode: "Code postal",
  site_postGate: "Après la barrière",
  site_potentialMatches: "Correspondances potentielles",
  site_preferedLanguage: "Langue de préférence",
  site_preferedModeCommunication: "Mode de communication de préférence",
  site_preGate: "Avant la barrière",
  site_privateVehicle: "Véhicule privé",
  site_processedBy: "Traité par",
  site_product: "Produit",
  site_products: "Produits",
  product_code: "Code JRV",
  code_bin: "Code emplacement",
  min_cap: "MIN",
  max_cap: "MAX",
  unites: " Unités",
  sidebar_vmi_config: "Configuration VMI",
  unit_weight: "Poids unitaire",
  inventory: "Inventaire",
  quantity_bin: "Quantité dans la bin",
  corres_level: "Correspond au niveau : ",
  diss_warning: "Voulez-vous vraiment dissocier ce produit?",
  calc_quant: "CALCUL QUANTITÉ",
  site_profile: "Profil",
  site_profileName: "Nom du profil",
  site_profileOverridenBy: "Profil remplacé par :",
  site_profilePhotos: "Photo(s) du profil",
  site_profiles: "Profils",
  site_profilesFound: "Profils trouvés",
  site_profilesOn: "Profil(s) sur",
  site_profilesOnOtherSites: "Profil(s) sur d’autres sites",
  site_profileTemperatureHistory: "Historique de température du profil",
  site_profileType: "Type de profil",
  site_questionnaires: "Questionnaire(s)",
  site_railDetectionEvent: "Rail Detection",
  site_rawValue: "Valeur brute",
  site_reasonForOverride: "Raison du remplacement",
  site_recentlyClosed: "Récemment fermés",
  site_ref: "# réf",
  site_registration: "Enregistrement",
  site_request: "Requête",
  site_reset: "Réinitialiser",
  site_results: "Résultats",
  site_resultsFound: "Résultats trouvés.",
  site_rfid: "RFID",
  site_riskLevel: "Niveau de risque",
  site_rowsPerPage: "Lignes par page :",
  site_RuleSets: "Ensembles de règles",
  site_save: "Sauvegarder",
  site_disableUser: "Désactiver l'utilisateur",
  site_enableUser: "Activer l'utilisateur",
  site_disableUserConfirm:
    "Êtes-vous sûr de vouloir désactiver cet utilisateur?",
  site_enableUserConfirm: "Êtes-vous sûr de vouloir activer cet utilisateur?",
  site_scanToCompleteMobile: "Lire pour terminer avec le cellulaire",
  site_scores: "Résultats",
  site_seal: "Sceau",
  site_search: "Rechercher",
  site_searchLicensePlate: "Recherche d'une plaque d'immatriculation",
  site_searchNameOcrLpr: "Chercher nom, OCR, LPR, etc.",
  site_searchOcrLpr: "Rechercher OCR/LPR",
  site_searchVehicle: "Recherche d'un véhicule",
  site_secondary: "Secondaire",
  site_secondaryDetails: "Détails secondaires",
  site_selectConfiguration: "Sélectionnez la configuration",
  site_selectDepartment: "Sélectionnez un département",
  site_selectPhotosForProfile:
    "Veuillez sélectionner les images que vous souhaitez associer au profil.",
  site_selectRowToViewDetails: "Sélectionnez une ligne pour voir le détail",
  site_setTemperatureText:
    "Pour choisir une température manuellement, cliquez sur un pixel à l'intérieur du rectangle vert qui correspond à la valeur/position désirée.",
  site_show: "Afficher",
  site_showAdditionalColumns: "Afficher les colonnes supplémentaires",
  site_showRoi: "Montrer le ROI",
  site_site: "Site :",
  site_site2: "Site",
  site_siteAndZone: "Site et zone",
  site_siteImpactCount: "Compte - Impact sur site",
  site_specificDateTime: "Entrez une date/heure précise",
  site_stage: "Étape",
  site_startDate: "Date de début",
  site_startTime: "Heure de début :",
  site_stateProvince: "État/Province",
  site_status: "Statut",
  site_structuralView: "Vue structurée",
  site_summary: "Résumé",
  site_tag: "Étiquette",
  site_tag2: "Éti.",
  site_tailgate: "Talonnage",
  site_tailgating: "Talonnage",
  site_tempBack: "Temp. Arrière",
  site_tempDisplayed: "Affichée",
  site_temperature: "Fièvre?",
  site_temperatureReadings: "Mesures de température",
  site_temperatureReadingsDetails: "Détails des mesures de température",
  site_temperatures: "Température",
  site_tempFront: "Temp. Avant",
  site_tempMeasured: "Mesurée",
  site_tempMiddle: "Temp. milieu",
  site_tempType: "Type temp.",
  site_tempVerbal: "Verbal",
  site_thermalROI: "Région d'intérêt thermale (ROI)",
  site_threatLevel: "Menace",
  site_threatLevel2: "Niveau de menace",
  site_time: "Heure",
  site_timeline: "Chronologie",
  site_timestamp: "Horodatage",
  site_to: "À",
  site_totalTimeAtDoor: "Temps total :",
  site_totalTimeAtGate: "Temps total à la barrière :",
  site_trailer: "Remorque",
  site_trailer1: "Remorque 1",
  site_trailer2: "Remorque 2",
  site_trailerId: "# Remorque",
  site_trailerName1: "Nom",
  site_trailerName2: "Nom",
  site_trailerType: "Type de remorque",
  site_trainId: "Nom du Train",
  site_truck: "Véhicule",
  site_truck2: "Véhicule",
  site_type: "Type :",
  site_type2: "Type",
  associated_products: "Produits associés",
  associate_product: "ASSOCIER PRODUIT",
  dissociate_product: "DISSOCIER PRODUIT",
  site_typeCorrectValue: "Tapez la bonne valeur",
  site_unidentified: "Non identifié",
  site_unindexedPhotos: "Photo(s) non indexée(s)",
  site_unknown: "Inconnu",
  site_unknownDriver: "Conducteur inconnu",
  site_unknownTrailer: "Remorque inconnue",
  site_unknownVehicle: "Véhicule inconnu",
  site_unmatch: "Non trouvé",
  site_unmatchedPhotos: "photo(s) non identifiée(s)",
  site_updateProfile: "Mettre à jour le profil",
  site_updatingProfile: "Mise à jour du profil",
  site_value: "valeur",
  site_valueConfirmed: "Valeur confirmée",
  site_valueConfirmedBy: "Valeur confirmée par :",
  site_valueCorrected: "Valeur corrigée",
  site_valueCorrectedBy: "Valeur corrigée par :",
  site_values: "valeurs",
  site_valueType: "Type de valeur",
  site_vehicle: "Véhicule",
  site_vehicleAccess: "Accès véhicules",
  site_vehicleAtGate: "Véhicule à la barrière",
  site_vehicleId: "# véhicule",
  site_vehicleName: "Nom",
  site_vehicleOcr: "OCR du véhicule",
  site_vehicleType: "Type de véhicule",
  site_verification: "Vérification",
  site_verified: "Vérifié",
  site_verify: "Vérifier",
  site_view: "Vue",
  site_viewAdditionalColumns: "Afficher colonnes additionnelles",
  site_viewCurrent: "Afficher infos courrantes",
  site_viewLess: "Voir moins",
  site_viewMore: "Afficher plus",
  site_vin: "NIV",
  site_walkInOut: "Accès humains",
  site_wasDetected: "a été détecté.",
  site_wearingMask: "Port du masque?",
  site_with: "Avec :",
  site_yardEventType: "Yard Event",
  site_year: "Année",
  site_yes: "Oui",
  site_zone: "Zone",
  site_zoneColor: "Couleur zone",
  site_currentSite: "Site courante",
  site_currentZone: "Zone courante",
  site_assignedSiteZone: "Site / Zone assignés",
  stat_childEventGroups:
    "Groupes d'événements enfants (humain, véhicule, remorque)",
  stat_comment: "Commentaires",
  stat_corrected_value: "Valeur corrigée",
  stat_correction_event_type_id: "Correction de type OCR/LPR",
  stat_count: "Compter",
  stat_detected_value: "Valeur détectée",
  stat_entranceExitDetail:
    "Détails d'entrée/sortie (lister uniquement les groupes d'événements où le statut = 3, 4 et 5)",
  stat_entranceExitSummary: "Sommaire Entrée/Sortie - Décompte par statut",
  stat_event_group_id: "Identifiant du groupe d'événements parent",
  stat_event_group_status_id: "Statut",
  stat_event_group_type_id: "Groupe d'événements parent",
  stat_event_id: "ID événement",
  stat_eventGroupId: "Identifiant du groupe d'événements",
  stat_eventGroupType: "Type de groupe d'événements",
  stat_eventType: "Type d'événement",
  stat_gateType: "Type de barrière",
  stat_imageCrop: "Recadrage de l'image",
  stat_lprOcrDetailedView: "Vue détaillée LPR/OCR",
  stat_lprOcrSummary: "Sommaire LPR/OCR",
  stat_parent_event_group_created_on: "Traité le",
  stat_parent_event_group_id: "Identifiant du groupe d'événements parent",
  stat_percentage: "Pourcentage",
  stat_percentageReviewed: "% / Révisé",
  stat_percentageTotal: "% / Total",
  stat_processed_on: "Traité le",
  stat_status: "Statut",
  stat_sum: "Somme",
  stat_type: "Type",
  stats_dacTitle: "Entrées DAC",
  stats_entrance: "Entrée",
  stats_exit: "Sortie",
  stats_frTitle: "FR",
  stats_hspIteractionPoints: "Points d'interaction HSP",
  stats_kiosk: "Kiosque",
  stats_lprTitle: "LPR",
  stats_mdcIteractionPoints: "Points d'interaction MDC",
  stats_ocrTitle: "OCR",
  stats_online: "En ligne",
  stats_profilesTitle: "PROFILS",
  stats_total: "Total",
  topbar_aboutLuke: "À propos de Stockify",
  topbar_admin: "Admin",
  topbar_companies: "Compagnies",
  topbar_configuration: "Configuration",
  topbar_dashboards: "Tableau de bord",
  topbar_driveInOut: "Accès véhicules",
  topbar_events: "Événements",
  topbar_home: "Accueil",
  topbar_hspCurrentStatusDescription:
    "Ce tableau de bord affiche les données à jour et tient compte des mises à jour manuelles.",
  topbar_hspDashboard: "Tableau de bord HSP principal",
  topbar_hspOriginalStatusDescription:
    "Ce tableau de bord affiche les données originales avant toute mise à jour manuelle.",
  topbar_idp: "IDP",
  topbar_mdcDashboard1: "Tableau de bord MDC entrées/sorties véhicules",
  topbar_mdcDashboard2: "Tableau de bord MDC principal",
  topbar_mdcInventoryDashboard: "Inventaire du site ",
  topbar_me: "Moi",
  topbar_mspMonthlyTransactionalStats:
    "Statistiques mensuelles sur les transactions MSP",
  topbar_myAccount: "Mon compte",
  topbar_profiles: "Profils",
  topbar_schedulerHumanAccess: "Planificateur - Entrée humains",
  topbar_schedulerVehicleAccess: "Planificateur - Accès véhicules",
  topbar_siteEntranceExit: "Entrée/Sortie",
  topbar_stats: "Stats",
  topbar_stats2: "Stats 2",
  topbar_stats3: "Stats 3",
  topbar_trainInOut: "Accès Trains",
  topbar_usersAndRoles: "Utilisateurs et Rôles",
  topbar_vmi_config: "Configuration VMI",
  topbar_walkInOut: "Accès humains",
  train_no_matches: "Aucun autocar trouvé",
  users_accessType: "Type d'accès",
  users_accountActivity: "Activité du compte",
  users_action: "Action",
  users_createAndInvite: "Créer et inviter",
  users_dateTime: "Date/Heure",
  users_fromProfile: "À partir d'un profil existant",
  users_incorrectEmail: "Nom d'utilisateur/Adresse courriel invalide",
  users_location: "Endroit (Adresse IP)",
  users_new: "Nouveau",
  users_newUser: "Nouvel utilisateur",
  users_updateUserRole: "Mettre à jour le rôle",
  users_editUserRole: "Modifier le rôle",
  users_requiredField: "Champ obligatoire",
  users_roles: "Rôles",
  users_singleUser: "Un utilisateur",
  users_usernameAlreadyInUse: "Le nom d'utilisateur est déjà utilisé.",
  users_users: "Utilisateurs",
  users_viewLukeProfile: "Afficher le profil Stockify",
  zone_same_name_warning:
    "Un emplacement avec ce nom existe déjà.  Veuillez entrer un nom différent.",
  assigned_company: "Companie assignés",
  show_company: "Afficher Companie",
  show_site: "Afficher Site",
  all_companies: "Tous les companies",
  all_sites: "Tous les sites",
  sidebar_trainmanifest: "Train Visibility",
  company_count_profile_onsite_details: "Détails sur place",
  dashboard_profilesPerPage: "Profiles per page",
  sidebar_VMI: "VMI",
  sidebar_vmiConfigurationMetrics: "VMI Configuration Metrics",
  dashboard_vmiConfigurationMetrics_company: "Companie",
  dashboard_vmiConfigurationMetrics_site: "Site",
  dashboard_vmiConfigurationMetrics_sector: "Secteur",
  dashboard_vmiConfigurationMetrics_vending_machine: "Distributeur automatique",
  dashboard_vmiConfigurationMetrics_vmi: "VMI",
  dashboard_vmiConfigurationMetrics_pzi: "PZI",
  dashboard_vmiConfigurationMetrics_distinct_products: "Produits distincts",
  dashboard_vmiConfigurationMetrics_users: "Utilisateurs",
  locomotive: "Locomotive",
  open_hopper: "Wagon trémie ouvert",
  closed_hopper: "Wagon trémie couvert",
  tanker: "Wagon citerne",
  boxcar: "Wagon couvert",
  flatcar: "Wagon plat",
  wellcar: "Wagon à évidement central",
  autorack: "Wagon porte-automobiles",
  centerbeam: "Wagon plat à support central",
  container: "Conteneur",
  trailer: "Remorque",
  gondola: "Wagon tombereau",
  coilcar: "Wagon tombereau à rouleaux de tôle",
  train_id: "Identifiant du train",
  current_state: "État actuel",
  train_layout: "Configuration du train",
  railcar: "Wagon",
  view_train_manifest: "Consulter le manifeste",
  matched: "Apparié",
  unmatched: "Non apparié",
  toggle_luke: "Vers profiles Stockify",
  toggle_manifest: "Vers le manifeste",
  estimated_arrival: "Arrivée estimée",
  luke_sequence: "Séquence Stockify",
  manifest_sequence: "Séquence Manifeste",
  manifest_position: "Position Manifeste",
  // TODO: REMOVE UNUSED AND DUPLICATES (START)
  number2: "Nombre",
  empty: "Vide",
  loaded: "Chargé",
  create_another: "Créer un autre",
  select_time_date: "SÉLECTIONNER ZONE",
  avail_time: "Plages Horaires Disponibles",
  spec_time: "Temps Spécifique",
  date_time: "La Date",
  file: "Déposer",
  time_zone: "Fuseau",
  role: "Filtre",
  mdc_timeline: "Chronologie",
  what_to: "Quoi faire ",
  ref: "Ref #",
  status: "État",
  PO: "PO",
  yard_visit: "Visite De La Cour",
  in_yard: "Dans la Cour",
  person_visit: "Visite de Personne",
  mdc_list: "Liste",
  drop: "Tomber",
  pickup: "Récupérer",
  number: "Numéro",
  file2: "Déposer",
  color_reservation: "Couleur de Réservation",
  arrival: "Arrivée",
  departure: "Départ",
  switch: "Changer",
  drag_drop: "(ou glissez-déposez les fichiers ici)",
  content_description: "Description du Contenu",
  liveload: "Charge en direct",
  liveunload: "Déchargement en Direct",
  miscellaneous: "Miscellaneous",
  reservation: "Réservation",
  newvisit: "VISITE DE COUR - NOUVELLE RÉSERVATION",
  activities: "Activités",
  summary: "Sommaire",
  move: "Mouvement",
  load: "Charge",
  unload: "Décharger",
  // TODO: REMOVE UNUSED AND DUPLICATES (END)
  sidebar_spot: "Vérification",
  idp_all_dates: "All Dates",
  idp_all_types: "All Types",
  idp_all_importers: "All Importers",
  idp_all_sizes: "All Sizes",
  idp_select_document: "Sélectionner le résultat ci-dessus",
  idp_extract_text: "Texte extrait",

  // Scan de code QR
  qrScanDecode: "Échec du décodage du code QR",
  qrScanFormat: "Format de code QR non valide",
  qrScanUrl: "Échec du chargement de l’URL de scan QR",
  qrScanNoUrl: "Aucune URL dans la configuration de scan QR",
};

// module.exports = Fr;
export default Fr;
